import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {AppConfig} from '../shared/app-config';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import {TemplateComponentVariable} from '../model/template-component-variable';
import {factory} from '../shared/app-logging';
import {ErrorDataService} from './error-data.service';

const logger = factory.getLogger('TemplateComponentVariablesService');

@Injectable({
  providedIn: 'root'
})
export class TemplateComponentVariablesService {
  private templateComponentVariables: Observable<TemplateComponentVariable[]>;
  private templateComponentVariablesLastCallError = false;

  constructor(private httpClient: HttpClient) {
  }

  public findTemplateComponentVariables(): Observable<TemplateComponentVariable[]> {
    if (this.templateComponentVariables && !this.templateComponentVariablesLastCallError) {
      logger.debug('findTemplateProductLines: Cache hit.');
    }
    this.templateComponentVariables = (this.templateComponentVariables && !this.templateComponentVariablesLastCallError) ?
      this.templateComponentVariables : this.fetchTemplateComponentVariables();
    return this.templateComponentVariables;
  }

  private fetchTemplateComponentVariables(): Observable<TemplateComponentVariable[]> {
    return this.httpClient.get(environment.contentLibraryApiBaseUrl + AppConfig.urlTemplateComponentVariables)
      .pipe(map(
        response => {
          const variables = [];

          for (const item of response['data']) {
            const variable = new TemplateComponentVariable(
              item.template_component_variable_id,
              item.display_label,
              item.format,
              item.sample_content,
              item.sample_content,
              item.product_line,
              item.source
            );

            variables.push(variable);
          }
          logger.debug(`${variables.length} variables fetched from REST`);
          this.templateComponentVariablesLastCallError = false;
          return variables;
        }
        ), catchError((err: Error | HttpErrorResponse) => {
          this.templateComponentVariablesLastCallError = true;
          const message = `In TemplateComponentVariablesService.findTemplateComponentVariables().`;
          return throwError(ErrorDataService.overLoadError(err, message));
        }),
        publishReplay(1),
        refCount());
  }

}
